import { formatDateRange } from '@spotify/confidence-core-react';

export const formatDateRangeFromStrings = (
  start?: string,
  end?: string,
): string => {
  const startString = start ?? end;
  const endString = end ?? start;
  if (!startString || !endString) return '';
  return formatDateRange(new Date(startString), new Date(endString));
};
